import { Flex, Input, Slider, Text } from '@chakra-ui/react';

const labelStyles = {
    mt: '2',
    ml: '-2.5',
    fontSize: 'sm',
};

function RateSliderControl({
    label,
    value,
    onChange,
    min,
    max,
    markers,
    defaultValue,
    trackBg,
    rangeBg,
    thumbSize,
}) {
    return (
        <Flex flexDirection="column" width='100%' mb={12}>
            <Text fontSize="lg" fontWeight="bold">{label}</Text>
            <Input
                value={value}
                onChange={(e) => {
                    const val = parseFloat(e.target.value);
                    if (!isNaN(val) && val >= 0) {
                        onChange(val);
                    }
                }}
                mb={4}
            />
            <Slider
                defaultValue={defaultValue}
                value={value}
                min={min}
                max={max}
                onChange={onChange}
            >
                {markers.map((marker) => (
                    <Slider.Marker key={marker.value} value={marker.value} {...labelStyles}>
                        {marker.label}
                    </Slider.Marker>
                ))}
                <Slider.Track bg={trackBg}>
                    <Slider.Range bg={rangeBg} />
                </Slider.Track>
                <Slider.Thumb boxSize={thumbSize} />
            </Slider>
        </Flex>
    );
}

export default RateSliderControl;
